// V&U Solutions horizontal logo — served from /public/vu-logo.png. Aspect ratio ≈ 1409:259 ≈ 5.44:1
export default function Logo({ height = 44, className = "" }) {
    return (
        <img
            src="/vu-logo.png"
            alt="V&U Solutions — Growth & Marketing"
            className={`shrink-0 select-none ${className}`}
            style={{ height, width: "auto", objectFit: "contain" }}
            draggable={false}
        />
    );
}
